import { render, staticRenderFns } from "./Validacao.vue?vue&type=template&id=271eb630"
import script from "./Validacao.vue?vue&type=script&lang=js"
export * from "./Validacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports